import { get } from 'lodash';

import { AiImageReq, AiMusicReq, AiTaskRsp, AiVideoReq, AiVoiceReq, DeleteAIResourceReq, DeleteAIResourceRsp, FetchModelsResp, GetAIResourceReq, GetAIResourceRsp, GetMusicByTaskIDReq, GetMusicByTaskIDRsp, GetTasksByIDReq, GetTasksByIDResp, OutPaintReq, PolishPromptReq, PolishPromptResp, RemoveBackgroundReq, RemoveBackgroundResp } from '@/interface/aigc';
import { isProd } from '@/utils/getApiDomain';
import { transformObjectDeep } from '@/utils/tans/object';

import { apiPath, apiPathServer } from './api-config';
import { CgiResp } from './cgi';
import { API_PREFIX, API_PREFIX_AGENT, API_PREFIX_AI_RESOURCE, request } from './request';

/**
 *  AI绘画
 * @param params
 * @returns
 */
export const aIDrawing = async (params: AiImageReq) => {
  const res = await request<CgiResp<AiTaskRsp>>(`${API_PREFIX_AI_RESOURCE}${apiPathServer.aiDrawing}`, {
    method: 'POST',
    body: transformObjectDeep(params, 'snake'),
  });
  return transformObjectDeep(res, 'camel') as CgiResp<AiTaskRsp>;
};

/**
 *  获取AIGC资源
 * @param id
 * @returns
 */
export const getAIResource = async (params: GetAIResourceReq) => {
  const res = await request<CgiResp<GetAIResourceRsp>>(`${API_PREFIX_AI_RESOURCE}${apiPathServer.getAIResource}`, {
    method: 'POST',
    body: transformObjectDeep(params, 'snake'),
  });
  return transformObjectDeep(res, 'camel') as CgiResp<GetAIResourceRsp>;
};

/**
 *  删除AIGC历史
 * @param id
 * @returns
 */
export const deleteAIResource = async (params: DeleteAIResourceReq) => {
  const res = await request<CgiResp<DeleteAIResourceRsp>>(`${API_PREFIX_AI_RESOURCE}${apiPathServer.deleteAIResource}`, {
    method: 'POST',
    body: transformObjectDeep(params, 'snake'),
  });
  return transformObjectDeep(res, 'camel') as CgiResp<DeleteAIResourceRsp>;
};

/**
 *  获取AI模型列表
 * @returns
 */
export const fetchModels = async () => {
  const res = await request<CgiResp<FetchModelsResp>>(`${API_PREFIX_AGENT}${apiPathServer.fetchModels}`, {
    method: 'POST',
    body: {},
  });
  return res;
};

/**
 *  描述润色
 * @param params
 * @returns
 */
export const polishPrompt = async (params: PolishPromptReq) => {
  const res = await request<CgiResp<PolishPromptResp>>(`${API_PREFIX_AI_RESOURCE}${apiPathServer.polishPrompt}`, {
    method: 'POST',
    body: transformObjectDeep(params, 'snake'),
  });
  return transformObjectDeep(res, 'camel') as CgiResp<PolishPromptResp>;
};

/**
 *  获取描述润色结果【已废弃】
 * @param ids
 * @returns
 */
export const getTasksByID = async (params?: GetTasksByIDReq) => {
  const res = await request<CgiResp<GetTasksByIDResp>>(`${API_PREFIX_AI_RESOURCE}${apiPathServer.getTasksByID}`, {
    method: 'POST',
    body: { ...params },
  });
  return res;
};

/**
 *  抠图
 * @param params
 * @returns
 */
export const removeBackground = async (params: RemoveBackgroundReq) => {
  const res = await request<CgiResp<RemoveBackgroundResp>>(`${API_PREFIX_AI_RESOURCE}${apiPathServer.removeBackground}`, {
    method: 'POST',
    body: { ...params },
  });
  return res;
};

/**
 *  扩图
 * @param params
 * @returns
 */
export const outPaint = async (params: OutPaintReq) => {
  const res = await request<CgiResp<{ url: string }>>(`${API_PREFIX_AI_RESOURCE}${apiPathServer.outPaint}`, {
    method: 'POST',
    body: { ...params },
  });
  return res;
};

/**
 *  AI生成音乐
 * @param params
 * @returns
 */
export const aiMusic = async (params: AiMusicReq) => {
  const res = await request<CgiResp<AiTaskRsp>>(`${API_PREFIX_AI_RESOURCE}${apiPathServer.aiMusic}`, {
    method: 'POST',
    body: transformObjectDeep(params, 'snake'),
  });
  return transformObjectDeep(res, 'camel') as CgiResp<AiTaskRsp>;
};

/**
 *  AI试听语音包
 * @param params
 * @returns
 */
export const aiVoice = async (params: AiVoiceReq) => {
  const res = await request<CgiResp<any>>(`${API_PREFIX}${apiPathServer.aiVoice}`, {
    method: 'POST',
    body: transformObjectDeep(params, 'snake'),
  });
  return res;
};

/**
 *  获取AI音乐（已废弃）
 * @param ids
 * @returns
 */
export const getMusicByID = async (params?: GetMusicByTaskIDReq) => {
  const res = await request<CgiResp<GetMusicByTaskIDRsp>>(`${API_PREFIX_AGENT}${apiPathServer.getMusicByID}`, {
    method: 'POST',
    body: { ...params },
  });
  return res;
};

/**
 *  获取AIGC Prompt标签表（无极wuji）
 */
export const fetchTags = async (): Promise<{}> => {
  const url = `${apiPath.tag}?env=${isProd ? 'prod' : 'test'}`;
  const res: any = await request(url);
  const payload = get(res, 'data');
  return payload?.list;
};

/**
 *  获取AI 资源使用白名单（无极wuji）
 */
export const fetchAiUsage = async (): Promise<{}> => {
  const url = `${apiPath.aiUsage}?env=${isProd ? 'prod' : 'test'}`;
  const res: any = await request(url);
  const payload = get(res, 'data');
  return payload?.list;
};

/**
 *  AI生成视频
 * @param params
 * @returns
 */
export const aiVideo = async (params: AiVideoReq) => {
  const res = await request<CgiResp<AiTaskRsp>>(`${API_PREFIX_AI_RESOURCE}${apiPathServer.aiVideo}`, {
    method: 'POST',
    body: transformObjectDeep({
      type: 1, // 火山视频服务
      volcGenVideoReq: params,
    }, 'snake'),
  });
  return transformObjectDeep(res, 'camel') as CgiResp<AiTaskRsp>;
};
